<template>
  <span v-if="dot" class="dot-status">
    <i class="dot-status-dot" :style="{ background: dot.color }" />
    {{ $te(dot.text) ? $t(dot.text) : dot.text || '' }}
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: null,
      default: null
    },
    // eslint-disable-next-line
    dots: {
      type: null
    }
  },
  computed: {
    dot() {
      if (!this.dots || !this.dots.get) return null
      const dot = this.dots.get(this.value)
      return dot
    }
  }
}
</script>

<style lang="scss" scoped>
.dot-status {
  display: inline-flex;
  align-items: center;
  &-dot {
    display: inline-block;
    width: 11px;
    height: 6px;
    border-radius: 6px;
    margin-right: 8px;
  }
}
</style>
